module.exports = __webpack_public_path__ + "static/media/photo179.9be19e63.jpg";